import { useEffect, useRef, useState } from 'react';
import { DL_BY_DEALER_NUMBER_API_URL, DL_QUERY_STRINGS } from '../../../../../../../constants/dealerLocator.constants';
import { windowService } from '../../../../../../../utils/window.utils.js';

const useSelectedDealer = (pageId, language): [any, string, (dealerNumber: string) => void] => {
  const getQuery = (key: string) => new URLSearchParams(windowService().location?.search).get(key);
  const query = getQuery(DL_QUERY_STRINGS.SELECTED_DEALER);
  const [selectedDealerNumber, setSelectedDealerNumber] = useState('');
  const controllerRef = useRef<AbortController | null>();
  const [selectedDealer, setSelectedDealer] = useState(null);

  const fetchDalerFromDealerPortal = (dealerNumber: string) => {
    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    const controller = new AbortController();
    controllerRef.current = controller;

    const queryUrlParams = new URLSearchParams({
      pageId: pageId,
      language: language,
      dealerNumber: dealerNumber,
    });

    const queyrUrl = `${DL_BY_DEALER_NUMBER_API_URL}?${queryUrlParams}`;

    return fetch(queyrUrl, { signal: controllerRef.current?.signal }).then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        console.error(`${res.status} : Failed to fetch dealers results.`);
      }
    });
  };

  useEffect(() => {
    if (!query || query === selectedDealerNumber) {
      if (!query) {
        setSelectedDealerNumber('');
        setSelectedDealer(null);
      }
      return;
    }

    fetchDalerFromDealerPortal(query)
      .then((data) => {
        setSelectedDealer(data?.dealershipResults?.[0] ?? null);
        setSelectedDealerNumber(data?.dealershipResults?.[0].dealerNumber);
      })
      .catch((error) => {
        setSelectedDealer(null);
        setSelectedDealerNumber('');
        console.error(error);
      });
  }, [selectedDealerNumber, query]);

  return [selectedDealer, selectedDealerNumber, setSelectedDealerNumber];
};

export default useSelectedDealer;
